import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ProjectCreateFieldEditPreview = {
  fieldPath: string;
  fieldLabel: string;
  original: string;
  revised: string;
  messageId: string;
};

/** 左侧「项目信息」中展示 AI 片段改写对比：原文灰色删除线，替换文红色（非加粗） */
export const useProjectCreateFieldEditPreviewStore = defineStore('projectCreateFieldEditPreview', () => {
  const activePreview = ref<ProjectCreateFieldEditPreview | null>(null);

  function setPreview(p: ProjectCreateFieldEditPreview) {
    activePreview.value = { ...p };
  }

  function clearPreview() {
    activePreview.value = null;
  }

  return { activePreview, setPreview, clearPreview };
});
